import { PropsWithChildren, createContext, useContext } from 'react'
import MaterialIcon from './MaterialIcon'

type MainProps = {
  filters: Record<string, string | number>
  removeFilter: (key: string) => void
}

const PillContext = createContext<MainProps | undefined>(undefined)

export function PillFilters({
  filters,
  removeFilter,
  children,
}: PropsWithChildren<MainProps>) {
  return (
    <PillContext.Provider value={{ filters, removeFilter }}>
      {children}
    </PillContext.Provider>
  )
}

type AutoPillProps = {
  label?: string
  caption?: string
  name: string
}

export function AutoFilter({ label, caption, name }: AutoPillProps) {
  const ctx = useContext(PillContext)

  if (!ctx) {
    return null
  }

  const { filters, removeFilter } = ctx

  if (!filters[name]) {
    return null
  }

  return (
    <span
      className="badge bg-secondary me-2 d-flex align-items-center pointer"
      onClick={() => removeFilter(name)}
    >
      {caption ?? `${label}: ${filters[name]}`}
      <MaterialIcon icon="close" fontSize={12} className="ms-2" />
    </span>
  )
}

type PillProps = {
  label: string
  onClick: () => void
}

export function PillFilter({ label, onClick }: PillProps) {
  return (
    <span
      className="badge bg-secondary me-2 d-flex align-items-center pointer"
      onClick={onClick}
    >
      {label}
      <MaterialIcon icon="close" fontSize={12} className="ms-2" />
    </span>
  )
}
